<template>
  <div>
        <div class="intro-header">
            <h1>INFORMACIÓN DE APLICACIÓN</h1>
        </div>

  <v-container>
    <v-layout text-xs wrap>
      <div class="about selected-centers">
        <div v-if="providers.length > 0">
        <h3>Aquí están sus centros seleccionados. Comuníquese con ellos directamente para obtener más información sobre la aplicación. Además, a continuación hay una lista de información específica del programa.</h3>
        <v-container fluid grid-list-md>
            <v-data-iterator
              :items="providers"
            hide-actions
              content-tag="v-layout"
              row
              wrap
            >
              <template v-slot:item="props">
                <v-flex
                  xs12
                  sm6
                  md4
                  lg3
                >
                  <v-card class="card-apply">
                    <v-card-title><h4>{{ props.item.ProviderName }}</h4></v-card-title>
                    <v-divider></v-divider>
                    <div>
                      <img alt="" class="card-image" v-if="props.item.FirstSteps" src="/images/fs4k-logo.png" /> <img alt="" class="card-image" v-if="props.item.HeadStart" src="/images/HeadStart.png" /> 
                        <img alt="" class="card-image" v-if="props.item.DeptEd" src="/images/DeptOfEd.png" /> <img alt="" class="card-image" v-if="props.item.ABCQualityRating && props.item.ABCQualityRating != 'Not Enrolled'" src="/images/DSS.png" />
                    </div>
                    {{ props.item.Address}}<br/>
                  {{ props.item.City}}, {{props.item.State}} {{ props.item.ZipCode}}<br/>
                  <span v-if="props.item.HeadStartRegistrationPhone">{{props.item.HeadStartRegistrationPhone}}</span>
                  <span v-if="!props.item.HeadStartRegistrationPhone">{{props.item.PhoneNumber}}</span>
                  <v-btn v-if="props.item.ApplicationUrl" round color="primary" @click="openApplicationUrl(props.item.ApplicationUrl)">Aplicar</v-btn>
                  </v-card>
                </v-flex>
              </template>
          
            </v-data-iterator>
        </v-container>

    <v-btn round color="primary" @click="$router.go(-1)"><span class="btn-white">back</span></v-btn>
    </div>
  </div>

<v-container>
  
            <img class="divider" style="max-width:120px;margin: 10px auto;display:block;" src="/images/color-blocks.svg"/>    
</v-container> 

<div class="homerow apply-programs">

           <div class="step">
              <div class="step-image">
                <img alt="" src="/images/fs4k-new.png">
              </div>
              <div class="step-content">
                <h2>SC First Steps 4K</h2>
                <p>
                  Póngase en contacto con su centro preferido para completar la solicitud. Para obtener más información, visite el <a href="https://scfirststeps.org/what-we-do/first-steps-4k/" target="_blank">sitio web de SC First Steps.</a>
                </p>
              </div>
           </div>

          
           <div class="step">
              <div class="step-image">
                <img alt="" src="/images/headstart-sq.png">
              </div>
              <div class="step-content">
                <h2>Head Start</h2>
                <p>
                  Número de teléfono de contacto que aparece en su centro preferido.
                </p>
                <v-btn round color="primary" @click="$router.push({name: 'provider_search'})">Programas</v-btn>
              </div>
           </div>

         
           <div class="step">
              <div class="step-image">
                <img alt="" src="/images/dss-sq.png">
              </div>
              <div class="step-content">
                <h2>DSS PROGRAMA DE BONOS DE CUIDADO INFANTIL SC</h2>
                <p>
                  Póngase en contacto con <a href="tel:8004760199">800-476-0199</a> para más información.
                </p>
              </div>
           </div>

           <div class="step">
              <div class="step-image">
                <img alt="" src="/images/dept-ed-3.png">
              </div>
              <div class="step-content">
                <h2>ESCUELA PÚBLICA SCDE PRE-K PROGRAMA EDUCATIVO DE LECTURA Y DESARROLLO TEMPRANO PARA NIÑOS (CERDEP)</h2>
                <p>
                  Póngase en contacto con su escuela zonal.
                </p>
                <v-btn round color="primary" @click="$router.push({name: 'provider_search'})">Programas</v-btn>
              </div>
           </div>           
  
  


      </div>
    </v-layout>
  </v-container>

    <div class="grey-bg">
        <v-container>  
        <v-card>
            <v-card-title class="cta-card">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12 sm4 class="red-section">
                        <img alt="" src="/images/icons/icon.png"/>
                    </v-flex>
                    <v-flex xs12 sm8 class="cta-card-text">
                        <v-layout row wrap justify-center align-center>
                            <v-flex xs10>
                                <div class="red-section-content">
                                    <h2>¡ENCUENTRE OPCIONES DE PRE-K CERCA DE TI!</h2>
                                    <p>Encuentre las escuelas preescolares que ofrecen programas para los cuales su hijo es elegible. Simplemente ingrese su dirección para encontrar un centro ubicado cerca de usted.</p>
                                </div>
                            </v-flex>
                            <v-flex xs2 class="arrow-img">
                                <a href="/provider-search"><img alt="Search for Providers" src="/images/icons/arrow.png"/></a>
                            </v-flex>
                        </v-layout>  
                    </v-flex>
                </v-layout>
            </v-card-title>
        </v-card>
        </v-container>
    </div>  
</div>
</template>

<script>
export default {
  data() {
    return {
      providers: []
    };
  },
  mounted: function() {
 
     this.$gtag.event('conversion',  {'send_to': 'AW-670219579/ggiCCIiUksMBELv6yr8C'});
      this.providers = window.JSON.parse(localStorage.selectedProviders);
      console.log(this.providers);
  },
  methods: {
        openApplicationUrl: function(applicationurl){
          window.open(applicationurl, "_blank");
        }
  },
  name: "apply",
  components: {}
};
</script>

<style scoped>
  .card-image {
    max-width:100%;
    padding:10px;
  }

  .card-apply{
    padding-left: 10px;
  }

   .red-section{
        background: #e94342;
        text-align: center;
    }

    .blue-table{
        background: #1b3675;
        color: white;
    }

    .cta-card{
        padding: 0;    
    }

    .cta-card-text{
        padding: 15px 15px;
    }
    .image-row img{
        width: 50%;
    }

</style>